import JSZip from "jszip";
import { useCallback } from "react";

interface CriarArquivoParams {
  cnpj: string;
  modulo: string;
  nomeDoArquivo: string;
  versao: string;
}

export function useCriarFileParaProcessamento() {

  const createFile = useCallback(
    async ({ cnpj, modulo, nomeDoArquivo, versao }: CriarArquivoParams): Promise<File> => {

      const zip = new JSZip();
      zip.file(`${modulo}-${cnpj}-${versao}.metadata`, "");
      const blobZip = await zip.generateAsync({ type: "blob" });
      const file = new File([blobZip], nomeDoArquivo, {
        type: "application/zip",
      });

      return file;
    },
    []
  );

  return { createFile };
}